export default function ProgressiveDisclosure() {
    function getDisclosureType(disclosure) {
        switch (disclosure.tagName.toLowerCase()) {
            case 'input':
                return disclosure.type.toLowerCase();
            default:
                return disclosure.tagName.toLowerCase();
        }
    }

    function getElementsInContainer(content) {
        let elements = [];
        if (content) {
            elements = Array.from(content.querySelectorAll('input, select, textarea'));
        }
        return elements;
    }

    function clearElements(content) {
        const elements = getElementsInContainer(content) || [];
        for (const element of elements) {
            element.value = '';
        }
    }

    function disclose(event, options = {}) {
        const { disclosure = event.target } = options;

        // Only run on elements that have the [data-disclosure] attribute
        // If the disclosure doesn't have the attribute, return
        if (!disclosure.hasAttribute('data-disclosure')) {
            return;
        }

        // Get the content associated with the button
        const content = document.querySelector(`#${disclosure.getAttribute('aria-controls')}`);

        // No point continuing without content
        if (!content) {
            return;
        }

        let showContent = false;
        let disclosureValue;

        switch (getDisclosureType(disclosure)) {
            case 'radio':
                // if we have a radio button, we also need to know what value will trigger a show
                if (disclosure.hasAttribute('data-disclosure-value')) {
                    disclosureValue = disclosure.getAttribute('data-disclosure-value');
                }
                if (disclosureValue) {
                    // show content if disclosure value == the value of the input disclosure
                    showContent = disclosure.checked && disclosure.value === disclosureValue;
                }

                // If this is a radio button and it was just selected, also update all other radios in the same group
                if (disclosure.checked && getDisclosureType(disclosure) === 'radio') {
                    const name = disclosure.getAttribute('name');
                    if (name) {
                        const allRadios = document.querySelectorAll(
                            `input[type="radio"][name="${name}"][data-disclosure]`
                        );
                        allRadios.forEach((radio) => {
                            if (radio !== disclosure) {
                                disclose(null, { disclosure: radio });
                            }
                        });
                    }
                }
                break;
            default:
                // If the element is checked/focused, show the content
                // Otherwise, hide it based on current aria-expanded or checkbox state
                if (getDisclosureType(disclosure) === 'checkbox') {
                    showContent = disclosure.checked;
                } else {
                    // For buttons, toggle based on current aria-expanded state
                    showContent = disclosure.getAttribute('aria-expanded') !== 'true';
                }
                break;
        }

        if (showContent) {
            disclosure.setAttribute('aria-expanded', true);
            content.classList.remove('hidden');
        } else {
            // sometimes we only want to process showing the content, not hiding it.
            disclosure.setAttribute('aria-expanded', false);
            content.classList.add('hidden');

            // clear data entered into fields which will now be hidden
            clearElements(content);
        }
    }

    function initializeDisclosures() {
        // Get the disclosure trigger elements
        const disclosures = Array.prototype.slice.call(document.querySelectorAll('[data-disclosure]'));

        // Loop through them with Array.forEach()
        disclosures.forEach((disclosure) => {
            let fireOnLoad = false;
            // add the appropriate listener depending on the trigger element, providing it's a form element
            switch (getDisclosureType(disclosure)) {
                case 'radio':
                    disclosure.addEventListener('change', disclose);
                    fireOnLoad = disclosure.checked;
                    break;
                case 'checkbox':
                    disclosure.addEventListener('change', disclose);
                    fireOnLoad = disclosure.checked;
                    break;
                default:
                    disclosure.addEventListener('click', disclose);
                    // For buttons, only fire on load if aria-expanded is initially true
                    fireOnLoad = disclosure.getAttribute('aria-expanded') === 'true';
                    break;
            }

            // fire show only on load - since elements will be hidden by default
            if (fireOnLoad) {
                disclose(null, { disclosure, onLoad: true });
            }
        });
    }

    // Initialize immediately and also on DOMContentLoaded for production use
    if (document.readyState === 'loading') {
        window.addEventListener('DOMContentLoaded', initializeDisclosures);
    } else {
        // DOM is already loaded, initialize immediately (useful for tests and dynamic content)
        initializeDisclosures();
    }
}
